import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getMotorcycles } from '../api';
import MotorcycleCard from '../components/MotorcycleCard';

const CONDITIONS = ['New', 'Used', 'Project / Parts Only'];

export default function Motorcycles() {
  const [motorcycles, setMotorcycles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [filter, setFilter] = useState({ make: '', condition: '', yearMin: '', yearMax: '', search: '' });
  const [page, setPage] = useState(1);

  const [makes, setMakes] = useState([]);

  useEffect(() => {
    fetch('/api/makes/all-brands')
      .then(r => r.json())
      .then(setMakes);
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = { page, limit: 24 };
    if (filter.make) params.make = filter.make;
    if (filter.condition) params.condition = filter.condition;
    if (filter.yearMin) params.yearMin = filter.yearMin;
    if (filter.yearMax) params.yearMax = filter.yearMax;
    if (filter.search) params.search = filter.search;
    getMotorcycles(params)
      .then(data => { setMotorcycles(data.motorcycles); setPagination(data.pagination); })
      .finally(() => setLoading(false));
  }, [page, filter]);

  const resetFilters = () => setFilter({ make: '', condition: '', yearMin: '', yearMax: '', search: '' });

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Motorcycles</h1>

      {/* Filters */}
      <div style={styles.filters}>
        <select style={styles.select} value={filter.make} onChange={e => setFilter(f => ({ ...f, make: e.target.value }))}>
          <option value="">All Makes</option>
          {makes.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
        <select style={styles.select} value={filter.condition} onChange={e => setFilter(f => ({ ...f, condition: e.target.value }))}>
          <option value="">All Conditions</option>
          {CONDITIONS.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <input
          style={styles.numberInput}
          type="number"
          placeholder="Year from"
          value={filter.yearMin}
          onChange={e => setFilter(f => ({ ...f, yearMin: e.target.value }))}
        />
        <input
          style={styles.numberInput}
          type="number"
          placeholder="Year to"
          value={filter.yearMax}
          onChange={e => setFilter(f => ({ ...f, yearMax: e.target.value }))}
        />
        <input
          style={styles.searchInput}
          placeholder="Search..."
          value={filter.search}
          onChange={e => setFilter(f => ({ ...f, search: e.target.value }))}
        />
        <button style={styles.resetBtn} onClick={resetFilters}>Reset</button>
      </div>

      {/* Grid */}
      {loading ? (
        <p style={styles.loading}>Loading...</p>
      ) : motorcycles.length === 0 ? (
        <p style={styles.empty}>No motorcycles found.</p>
      ) : (
        <div style={styles.grid}>
          {motorcycles.map(m => (
            <Link key={m._id} to={`/motorcycles/${m._id}`}>
              <MotorcycleCard motorcycle={m} />
            </Link>
          ))}
        </div>
      )}

      {/* Pagination */}
      {pagination.pages > 1 && (
        <div style={styles.pagination}>
          <button
            style={{ ...styles.pageBtn, opacity: page === 1 ? 0.5 : 1 }}
            disabled={page === 1}
            onClick={() => setPage(p => p - 1)}
          >Prev</button>
          {Array.from({ length: Math.min(pagination.pages, 5) }, (_, i) => {
            let pageNum;
            if (pagination.pages <= 5) pageNum = i + 1;
            else if (page <= 3) pageNum = i + 1;
            else if (page >= pagination.pages - 2) pageNum = pagination.pages - 4 + i;
            else pageNum = page - 2 + i;
            return (
              <button
                key={pageNum}
                style={{
                  ...styles.pageBtn,
                  background: page === pageNum ? '#4f46e5' : '#fff',
                  color: page === pageNum ? '#fff' : '#1e293b',
                  border: page === pageNum ? '1px solid #4f46e5' : '1px solid #e2e8f0'
                }}
                onClick={() => setPage(pageNum)}
              >
                {pageNum}
              </button>
            );
          })}
          <button
            style={{ ...styles.pageBtn, opacity: page === pagination.pages ? 0.5 : 1 }}
            disabled={page === pagination.pages}
            onClick={() => setPage(p => p + 1)}
          >Next</button>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { maxWidth: 1200, margin: '0 auto', padding: 24 },
  title: { fontSize: 28, fontWeight: 700, color: '#1e293b', margin: '0 0 20px' },
  filters: { display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 24, padding: 16, background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0' },
  select: { padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13, background: '#fff' },
  numberInput: { padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13, width: 100 },
  searchInput: { padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13, flex: 1, minWidth: 150 },
  resetBtn: { padding: '8px 16px', background: '#64748b', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 },
  loading: { textAlign: 'center', padding: 60, color: '#94a3b8' },
  empty: { textAlign: 'center', padding: 60, color: '#94a3b8' },
  pagination: { display: 'flex', gap: 4, justifyContent: 'center', marginTop: 24 },
  pageBtn: { padding: '8px 14px', border: '1px solid #e2e8f0', borderRadius: 6, cursor: 'pointer', fontSize: 13, background: '#fff' }
};